import { get, replace } from "lodash";
import { staticPage } from "grandus-lib/utils/fetches";

import styles from "./static.page.module.scss";
import Image from "grandus-lib/components-atomic/image/Image";
import MetaData from "grandus-lib/components-atomic/MetaData";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const Page = (props) => {
  const { page } = props;
  const { title, customCss = "", customJavascript = "", content = "" } = page;

  const meta = {
    title: get(page, "title"),
    photo: get(page, "photo", {}),
  };

  return (
    <div className={`container guttered ${styles.wrapper}`}>
      <MetaData {...meta} />
      {customCss ? (
        <style
          dangerouslySetInnerHTML={{
            __html: customCss,
          }}
        />
      ) : null}
      <h1>{title}</h1>
      {get(page, "photo") ? (
        <Image
          className={styles.mainImage}
          photo={photo}
          size={"1100x600"}
          type={"jpg"}
          useNextImage={true}
          priority={true}
        />
      ) : (
        ""
      )}

      <div
        dangerouslySetInnerHTML={{
          __html: replace(
            content,
            new RegExp('"/files', "gi"),
            `"${process.env.NEXT_PUBLIC_IMAGE_HOST}/files`
          ),
        }}
      />
      {customJavascript ? (
        <div
          dangerouslySetInnerHTML={{
            __html: replace(
              customJavascript,
              new RegExp('"/files', "gi"),
              `"${process.env.NEXT_PUBLIC_IMAGE_HOST}/files`
            ),
          }}
        />
      ) : null}
    </div>
  );
};

export async function getServerSideProps(context) {
  const staticPageProps = staticPage.serverSideProps(context);
  return {
    props: {
      ...(await staticPageProps).props,
      ...(await serverSideTranslations(context?.locale, ["common", "product"])),
    },
  };
}

export default Page;
